<div
  class="sticky top-0 z-50 bg-white shadow-sm border-b border-gray-200 px-6 py-4"
>
  <div class="flex items-center justify-between max-w-7xl mx-auto">
    <span class="text-lg font-semibold text-gray-900">Farm Woodlot Tool</span>
    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="showWelcome()"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
        id="about-tool"
      >
        About tool
      </button>
      <a
        type="button"
        [routerLink]="['/map']"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200 no-underline"
        id="map"
      >
        Map
      </a>
    </div>
  </div>
</div>
<div class="flex content-center justify-center px-24 py-4">
  <!-- <div class="btn btn-primary" (click)="generatePDFHandler()">Download PDF</div> -->
  <app-accordion classes="flex-grow" type="multiple">
    <!-- Stage 1: Species and Planting Materials -->
    <app-accordion-item
      heading="{{ reportTarget.name }} - Species and Planting Materials"
      value="accordion-item-1"
    >
      <app-materials-species-planting
        (parentEventTransmitter)="setStageTemplateData($event)"
      >
      </app-materials-species-planting>

      @if(stageCompletedTemplate()[1].completed === true) {

      <button
        [ngpDialogTrigger]="dialog"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Show PDF
      </button>
      }
    </app-accordion-item>
    <!-- Stage 2: Fencing Materials Required -->
    <app-accordion-item
      heading="{{ reportTarget.name }} - Fencing Materials Required">
      <app-tree-protection
        (parentEventTransmitter)="setStageTemplateData($event)"
        [fenceSize]="fenceLength ? fenceLength : 0"
      ></app-tree-protection>

      @if(stageCompletedTemplate()[2].completed === true) {
      <button
        [ngpDialogTrigger]="dialog"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Show PDF
      </button>
      }
    </app-accordion-item>
    <!-- Stage 3: Site Establishment and Weed Control Guidelines -->
    <app-accordion-item
      heading="{{
        reportTarget.name
      }} - Site Establishment and Weed Control Guidelines"
    >
      <app-site-preparation-guidelines></app-site-preparation-guidelines>
    </app-accordion-item>
    <!-- Stage 4: Estimations of yields for final harvest -->
    <app-accordion-item
      heading="{{ reportTarget.name }} - Final Harvest Yield Estimations"
    >
      <app-indicative-yields
        (parentEventTransmitter)="setStageTemplateData($event)"
        [reportType]="reportType"
        [id]="propertyPaddockID"
      >
      </app-indicative-yields>

      @if(stageCompletedTemplate()[4].completed === true) {
      <button
        [ngpDialogTrigger]="dialog"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Show PDF
      </button>
      }
    </app-accordion-item>
    <!-- Stage 5: Market Guidelines -->
    <app-accordion-item heading="Market Guidelines">
      <app-market-guidelines
        (parentEventTransmitter)="setStageTemplateData($event)"
      ></app-market-guidelines>
      @if(stageCompletedTemplate()[5].completed === true) {

      <button
        [ngpDialogTrigger]="dialog"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Show PDF
      </button>

      }
    </app-accordion-item>
    <!-- Stage 6: PTR Guidelines -->
    <app-accordion-item heading="PTR Guidelines">
      <app-ptr-guidelines></app-ptr-guidelines>
      @if(stageCompletedTemplate()[6].completed === true) {

      <button
        [ngpDialogTrigger]="dialog"
        class="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded transition-colors duration-200"
      >
        Show PDF
      </button>
      }
    </app-accordion-item>
  </app-accordion>

  <!-- <app-tree-protection></app-tree-protection> -->
  <ng-template #dialog let-close="close">
    <esk-dialog header="Woodlot PDF View">
      <iframe
        class="w-full h-full border-0"
        [src]="safeUrl()"
        title="pdf-preview"
      ></iframe>
      <div
        class="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
      >
        <button
          (click)="close()"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
        >
          Cancel
        </button>
        <button
          (click)="close(); save()"
          class="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors duration-200"
        >
          Confirm
        </button>
      </div>
    </esk-dialog>
  </ng-template>
</div>
